import React from 'react';
import styles from './index.module.less';
import useScreenSize from '@/lib/hooks/utils/useScreenSize';

const APIFooterContent = () => {
  const { width } = useScreenSize();

  return (
    <div className={styles.content}>
      <div className={styles.leftContainer}>
        <div className={styles.title}>{'Get in touch'}</div>
        <p className={styles.desc}>{`Built something cool with our API? Need support or have questions?`}</p>
        <p className={styles.desc}>{`Reach out to us—we're here to help and excited to hear your ideas!`}</p>
        <span className={styles.linkBtn}>
          <a href={'mailto:help.pumpsoul@gmail.com'}>{`Contact Us via Email`}</a>
        </span>
      </div>

      <div className={styles.rightContainer}>
        <img
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
          src={width > 900 ? '/images/api/api-footer-icon.webp' : '/images/api/api-footer-icon-mobile.webp'}
          alt="api-footer-icon"
        />
      </div>
    </div>
  );
};

export default APIFooterContent;
